/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Template_Save_MineInputs */

const en_us2_coaching_template_save_mine = /** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save my current plan as a template`)
};

const pt_br2_coaching_template_save_mine = /** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar meu plano atual como modelo`)
};

const pt_pt2_coaching_template_save_mine = /** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar meu plano atual como modelo`)
};

/** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */
const es_419_coaching_template_save_mine = en_us2_coaching_template_save_mine;

/** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */
const fr_fr2_coaching_template_save_mine = en_us2_coaching_template_save_mine;

/** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */
const de_de2_coaching_template_save_mine = en_us2_coaching_template_save_mine;

/** @type {(inputs: Coaching_Template_Save_MineInputs) => LocalizedString} */
const it_it2_coaching_template_save_mine = en_us2_coaching_template_save_mine;

/**
* | output |
* | --- |
* | "Save my current plan as a template" |
*
* @param {Coaching_Template_Save_MineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_template_save_mine = /** @type {((inputs?: Coaching_Template_Save_MineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Template_Save_MineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_template_save_mine(inputs)
	if (locale === "es-419") return es_419_coaching_template_save_mine(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_template_save_mine(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_template_save_mine(inputs)
	if (locale === "de-DE") return de_de2_coaching_template_save_mine(inputs)
	if (locale === "it-IT") return it_it2_coaching_template_save_mine(inputs)
	return en_us2_coaching_template_save_mine(inputs)
});
export { coaching_template_save_mine as "coaching.template_save_mine" }